module.exports = __webpack_public_path__ + "assets/img/3.74c6111f.png";